<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <v-tabs>
        <v-tab @click="currentTab = 'Overview'">Overview</v-tab>
        <v-tab @click="currentTab = 'Financial'">Financial</v-tab>
        <!-- <v-tab @click="currentTab = 'Services'">Services</v-tab> -->
      </v-tabs>
    </v-toolbar>
    
    <div v-if="currentTab=='Overview'">
      <v-layout justify-center align-top wrap v-if="contactInfo&&serviceAccount" mt-3>
      <v-flex xs4>
        <v-card class="rounded-card pt-3" color="white">
          <h3>Contact Details</h3>
          <v-card-text>
            <v-layout justify-left align-center wrap>
              <v-flex xs4 mx-1>
                <h4 class="grey--text text-xs-left">First Name:</h4>
              </v-flex>
              <v-flex xs4 mx-1>
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ contactInfo.name }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1>
                <h4 class="grey--text text-xs-left">Surname:</h4>
              </v-flex>
              <v-flex xs4 mx-1>
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ contactInfo.surname }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.idNumber">
                <h4 class="grey--text text-xs-left">ID Number:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.idNumber">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ contactInfo.idNumber }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.mobileNumber">
                <h4 class="grey--text text-xs-left">Mobile No:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.mobileNumber">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ contactInfo.mobileNumber }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="datatillIntegration&&datatillData&&datatillData.customer">
                <h4 class="grey--text text-xs-left">Account Code:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="datatillIntegration&&datatillData&&datatillData.customer">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ datatillData.customer.accounting_code }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.emailAddress">
                <h4 class="grey--text text-xs-left">Email Address:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.emailAddress">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ contactInfo.emailAddress }}
                </h4>
              </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card>
        <v-flex mt-1 v-if="serviceAccount">
          <documentcomponent
            :key="key"
            :contactid="this.serviceAccount.contactId"
            :serviceaccountid="this.$route.params.serviceAccountId"
            :documents="contactDocuments"
            @documentChange="fetchDocuments"
          ></documentcomponent>
        </v-flex>
      </v-flex>
       <v-flex grow>
        <v-layout justify-center align-center wrap v-if="serviceAccount">
          <v-flex xs12>
            <v-card class="rounded-card pt-3" color="white">
              <h3>Address Info</h3>
              <v-card-text>
                <v-layout justify-center align-center wrap class="text-xs-left">
                  <v-flex xs6>
                      <v-layout justify-center align-center wrap class="text-xs-left">
                           <v-flex xs4 mx-1 v-if="serviceAccount.location.unitNo">
                      <h4 class="grey--text">Unit:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.location.unitNo">
                      <span class="grey--text">
                        {{ serviceAccount.location.unitNo }}
                      </span>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.location.erfNo">
                      <h4 class="grey--text">Erf:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.location.erfNo">
                      <span class="grey--text">
                        {{ serviceAccount.location.erfNo }}
                      </span>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.location.otherNo">
                      <h4 class="grey--text">Other No:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.location.otherNo">
                      <span class="grey--text">
                        {{ serviceAccount.location.otherNo }}
                      </span>
                    </v-flex>

                    <v-flex
                      xs4
                      mx-1
                      v-if="serviceAccount.location.complexStreetName"
                    >
                      <h4 class="grey--text">Street:</h4>
                    </v-flex>
                    <v-flex
                      xs4
                      mx-1
                      v-if="serviceAccount.location.complexStreetName"
                    >
                      <span class="grey--text">
                        {{ serviceAccount.location.complexStreetName }}
                      </span>
                    </v-flex>

                    <v-flex xs4 mx-1>
                      <h4 class="grey--text">Network:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <span class="grey--text">
                        {{ serviceAccount.location.locationNetwork.name }}
                      </span>
                    </v-flex>

                    <v-flex xs4 mx-1>
                      <h4 class="grey--text">Fibre Installed:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <v-icon v-if="serviceAccount.location.fibrePulled" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                    </v-flex>

                   <v-flex xs4 mx-1>
                      <h4 class="grey--text">Equipment Installed:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <v-icon v-if="serviceAccount.location.equipmentInstalled" color="light-green">check_circle</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                    </v-flex>
                      </v-layout>
                   
                  </v-flex>
                  <v-flex xs6>
                    <gmap-map
                      ref="mapRef"
                      :center="center"
                      :zoom="14"
                      style="width: 100%; height: 25vh"
                    >
                      <gmap-marker :position="markerPosition"></gmap-marker>
                    </gmap-map>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
       <v-flex xs3 mt-1>
          <v-card white class="rounded-card">
              <h3>Service Account Details</h3>
              <v-card-text>
                  <v-layout justify-left align-center wrap class="text-xs-left">
              <v-flex xs4 mx-1 v-if="customerAccount.supplierOrganisation">
                <h4 class="grey--text text-xs-left">Network Operator:</h4>
              </v-flex>
              <v-flex xs6 mx-1 v-if="customerAccount.supplierOrganisation">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ customerAccount.supplierOrganisation.name }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="serviceAccount.device">
                <h4 class="grey--text text-xs-left">Device:</h4>
              </v-flex>
              <v-flex xs6 mx-1 v-if="serviceAccount.device">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ serviceAccount.device.deviceMakeModel.deviceMake.name }} {{ serviceAccount.device.deviceMakeModel.name }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="deviceStatus">
                <h4 class="grey--text text-xs-left">Device Status:</h4>
              </v-flex>
              <v-flex xs6 mx-1 v-if="deviceStatus">
                  <v-chip v-if="deviceStatus.isOnline" color="light-green" class="white--text">Online</v-chip>
                  <v-chip v-else-if="!deviceStatus.isOnline" color="light-green" class="white--text">Offline</v-chip>
              </v-flex>
                  </v-layout>
              </v-card-text>
          </v-card>
          <v-card class="rounded-card mt-1">
              <h3>Radius Account Details</h3>
            <v-card-text>
               <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs4 mx-1>
                      <h4 class="grey--text">Package Name:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{serviceAccount.packagesIsp.name}}</span>
                    </v-flex>
                     <v-flex xs4 mx-1>
                      <h4 class="grey--text">Speed:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}/{{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}} Mbps</span>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <h4 class="grey--text">Monthly Fee:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{serviceAccount.packagesIsp.recurringPriceVatInc | currency}}</span>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="serviceAccount.pppoeUsername">
                <h4 class="grey--text text-xs-left">PPPoE Username:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="serviceAccount.pppoeUsername">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ serviceAccount.pppoeUsername }}
                </h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="serviceAccount.pppoePassword">
                <h4 class="grey--text text-xs-left">PPPoE Password:</h4>
              </v-flex>
              <v-flex xs4 mx-1 v-if="serviceAccount.pppoePassword">
                <h4 class="grey--text font-weight-light text-xs-left">
                  {{ serviceAccount.pppoePassword }}
                </h4>
              </v-flex>
               </v-layout>
            </v-card-text>
          </v-card>
          <v-card white class="rounded-card mt-1" v-if="datatillData&&datatillData.usage">
              <h3>Usage  Details</h3>
              <v-card-text>
                  <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs4 mx-1>
                      <h4 class="grey--text">Current Monthly Usage:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <v-chip small color="blue" class="white--text">{{datatillData.usage.usage_detail}}</v-chip>
                    </v-flex>
                     <v-flex xs4 mx-1>
                      <h4 class="grey--text">Cap Limit:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{datatillData.usage.limit_desc}}</span>
                    </v-flex>
                     <v-flex xs4 mx-1>
                      <h4 class="grey--text">Remaining Limit:</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{datatillData.usage.remaining_desc}}</span>
                    </v-flex>
                  </v-layout>
              </v-card-text>
          </v-card>
      </v-flex>
      <v-flex grow>
        <v-card class="rounded-card">
          <v-tabs grow>
            <v-tab @click="sessionTab='active'">Active Sessions</v-tab>
            <v-tab @click="sessionTab='all'">Previous Sessions</v-tab>
          </v-tabs>
          <v-card-text>
            <div v-if="sessionTab=='active'">
              <v-data-table
                  :rows-per-page-items="[5]"
                  :items="activeRadiusSessions"
                  :headers="sessionHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.nasipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.framedipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.username}}</td>
                      <td class="text-xs-center" >{{props.item.callingstationid}}</td>
                      <td class="text-xs-center" >{{props.item.acctstarttime}}</td>
                      <td class="text-xs-center" >{{props.item.acctstoptime}}</td>

                  </template>
        </v-data-table>
            </div>
            <div v-if="sessionTab=='all'">
               <v-data-table
                  :rows-per-page-items="[5]"
                  :items="previousRadiusSessions"
                  :headers="sessionHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.nasipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.framedipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.username}}</td>
                      <td class="text-xs-center" >{{props.item.callingstationid}}</td>
                      <td class="text-xs-center" >{{props.item.acctstarttime}}</td>
                      <td class="text-xs-center" >{{props.item.acctstoptime}}</td>

                  </template>
        </v-data-table>
            </div>

          </v-card-text>
        </v-card>
      </v-flex>
      </v-layout>
    </div>
    <div v-if="currentTab=='Financial'">
      <v-flex grow mb-1 v-if="$store.state.currentOrg.org.accountingSystem =='SageOne'" >
            <v-card class="rounded-card">
              <v-card-text>
                    <h3 class="dark-grey--text font-weight-bold">
                      Financial
                    </h3>
                    <v-layout mt-2 align-center justify-left wrap class="text-xs-left">
                        <v-flex xs12 v-if="ageAnalysis" class="grey--text text-xs-center">
                          <v-layout justify-center align-top wrap>
                              <v-flex xs3><b>120 +</b></v-flex>
                              <v-flex xs3><b>90</b></v-flex>
                              <v-flex xs3><b>60</b></v-flex>
                              <v-flex xs3><b>30</b></v-flex>

                          </v-layout>
                          <v-layout justify-center align-center wrap>
                              <v-flex xs3><span>{{ageAnalysis.Days120Plus|currency}}</span></v-flex>
                              <v-flex xs3><span>{{ageAnalysis.Days90|currency}}</span></v-flex>
                              <v-flex xs3><span>{{ageAnalysis.Days60|currency}}</span></v-flex>
                              <v-flex xs3><span>{{ageAnalysis.Days30|currency}}</span></v-flex>
                              <!-- <v-flex xs2><span>{{ageAnalysis.Current|currency}}</span></v-flex> -->
                          </v-layout>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout align-center justify-center>
                            <v-flex xs6 mx-1 v-if="ageAnalysis">
                            <h3 class="grey--text">Current Balance:</h3>
                          </v-flex>
                          <v-flex xs4 mx-1 v-if="ageAnalysis">
                            <v-chip color="blue" class="white--text">{{ageAnalysis.Current|currency}}</v-chip>
                          </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout align-center justify-center>
                            <v-flex xs6 mx-1 v-if="customerAccount">
                            <h3 class="grey--text">Recurring Invoice:</h3>
                          </v-flex>
                          <v-flex xs4 mx-1 v-if="customerAccount">
                            <h3 class="grey--text font-weight-light">{{customerAccount.recurringInvoiceReference}}</h3>
                          </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                          <SageTransactions :transactions="transactions" :taxtypes="taxTypes"></SageTransactions>
                        </v-flex>
                        <v-flex xs6 v-if="recurringInvoice" class="text-xs-left">
                          <v-card class="rounded-card" fill-height>
                            <h3 class="text-xs-center ">Recurring Invoice</h3>
                            <v-card-text>
                              <v-layout align-center justify-left wrap >
                                <v-flex xs5 mx-1><h3 class="grey--text">Invoice Number:</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text font-weight-light">{{recurringInvoice.DocumentNumber}}</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text">Amount Excl VAT:</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text font-weight-light">{{recurringInvoice.Exclusive | currency}}</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text">VAT:</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text font-weight-light">{{recurringInvoice.Tax | currency}}</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text">Total:</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text font-weight-light">{{recurringInvoice.Total | currency}}</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text">Start Date:</h3></v-flex>
                                <v-flex xs5 mx-1><h3 class="grey--text font-weight-light">{{recurringInvoice.Schedule.StartDate}}</h3></v-flex>
                                <v-flex xs12></v-flex>
                                <v-flex xs12>
                                  <v-data-table
                    :items="recurringInvoice.Lines"
                    :headers="invoiceHeaders"
                    :rows-per-page-items="4"
                    >
                    \<template v-slot:items="props">
                  <td > {{props.item.Description}}</td>
                  <td > {{props.item.Quantity}}</td>
                  <!-- <td > {{taxtypes.find(x=>x.ID==props.item.TaxTypeId).Name}}</td> -->
                  <td > {{props.item.UnitPriceExclusive | currency}}</td>
                  <td > {{props.item.UnitPriceInclusive | currency}}</td>
                  <td > {{props.item.Total | currency}}</td>
                  </template>                    
                    </v-data-table>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>

                        
                    </v-layout>
            

              </v-card-text>
            </v-card>
          </v-flex>
    </div>
    <div v-if="currentTab=='Services'">

    </div>
    
      
         
       <v-flex xs3 v-if="datatillBillingDetails">
              <v-card class="rounded-card pt-3" color="white">
                  <h3 mt-1>Financials</h3>
                  <v-card-text>
                      <v-card flat color="white" class="grey--text mb-1">
                          <v-layout justify-center align-center wrap>
                              <v-flex xs2><span>120 Day</span></v-flex>
                              <v-flex xs2><span>90 Day</span></v-flex>
                              <v-flex xs2><span>60 Day</span></v-flex>
                              <v-flex xs2><span>30 Day</span></v-flex>
                              <v-flex xs2><span>Current</span></v-flex>

                          </v-layout>
                          <v-layout justify-center align-center wrap>
                              <v-flex xs2><span>{{datatillAgeAnalysis['120d']|currency}}</span></v-flex>
                              <v-flex xs2><span>{{datatillAgeAnalysis['90d']|currency}}</span></v-flex>
                              <v-flex xs2><span>{{datatillAgeAnalysis['60d']|currency}}</span></v-flex>
                              <v-flex xs2><span>{{datatillAgeAnalysis['30d']|currency}}</span></v-flex>
                              <v-flex xs2><span>{{datatillAgeAnalysis.current|currency}}</span></v-flex>

                          </v-layout>
                      </v-card>
                      <v-card flat xs12 v-for="inv in datatillBillingDetails.documents" :key="inv.id">
                          <v-layout justify-center align-center wrap>
                              <v-flex xs4>
                                  <h4 class="grey--text font-weight-light">{{inv.document_number}}</h4>
                              </v-flex>
                              <v-flex xs4>
                                  <h4 class="grey--text font-weight-light">{{inv.document_amount | currency}}</h4>
                              </v-flex>
                              <v-flex xs4>
                                  <v-chip small v-if="inv.paid == 'Paid'" color="light-green" class="white--text">Paid</v-chip>
                                  <v-chip v-else small color="red" class="white--text">{{inv.paid}}</v-chip>
                              </v-flex>
                          </v-layout>
                      </v-card>
                  </v-card-text>
              </v-card>
          </v-flex>
          <v-flex xs6 sm3 mt-1 v-if="datatillIntegration &&datatillData&&datatillData.customer">
              <linechart
          v-if="datatillDataLoaded"
          :chartdata="datatillDataMonthly"
          :options="datatillDataMonthlyOptions"
        ></linechart>
          </v-flex>
          <v-flex xs6 sm3 mt-1 v-if="datatillIntegration &&datatillData&&datatillData.customer">
              <linechart
          v-if="datatillDataLoaded"
          :chartdata="datatillDataDaily"
          :options="datatillDataDailyOptions"
        ></linechart>
          </v-flex>
           <v-flex xs6 sm3 mt-1 v-if="datatillIntegration &&datatillData&&datatillData.customer">
              <v-card class="rounded-card mt-1">
                  <h3>Active Radius Sessions</h3>
                  <v-card-text ma-1>
                      <div v-if="activeRadiusSessions&&activeRadiusSessions.length>0">
                      <v-card ma-1 pa-3 hover xs12 v-for="session in activeRadiusSessions" :key="session.id">
                          <v-layout justify-left align-center wrap class="text-xs-left grey--text">
                              <v-flex xs4 mx-1>
                                  <h4>IP Address:</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4 class="font-weight-light">{{session.ip_address}}</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4>NAS IP Address:</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4 class="font-weight-light">{{session.nas_ip_address}}</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4>Session Duration:</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4 class="font-weight-light">{{session.duration_since}}</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4>Download Speed:</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4 class="font-weight-light">{{session.download_speed/(1024*1024)}} Mbps</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4>Upload Speed:</h4>
                              </v-flex>
                              <v-flex xs4 mx-1>
                                  <h4 class="font-weight-light">{{session.upload_speed/(1024*1024)}} Mbps</h4>
                              </v-flex>
                          </v-layout>
                      </v-card>

                      </div>
                      <div v-else>
                          <span class="grey--text">No active sessions</span>
                      </div>
                  </v-card-text>
              </v-card>
          </v-flex>
         
        
    </v-layout>
  </div>
</template>

<script>
import Api from "@/services/Api";
import Tags from "@/components/Tags.vue";
import DocumentCard from "@/components/DocumentCard.vue";
import LineChart from "./LineChart.vue";
import axios from "axios";
import SageTransactions from "../components/SageTransactions";
const CancelToken = axios.CancelToken;
let source = null;
export default {
  props: ["contactsummary", "totalitems"],
  components: {
    tagscomponent: Tags,
    documentcomponent: DocumentCard,
    linechart: LineChart,
    SageTransactions,
  },
  data() {
    return {
      activeRadiusSessions: [],
      previousRadiusSessions: [],
      contactInfo: [],
      currentTab: "Overview",
      datatillData: null,
      datatillAgeAnalysis: null,
      datatillBillingDetails: null,
      datatillCustomerDetails: null,
      datatillDataLoaded: false,
      datatillDataMonthly: {},
      datatillDataMonthlyOptions: {},
      datatillDataDaily: {},
      datatillDataDailyOptions: {},
      datatillIntegration: false,
      deviceStatus: null,
      contactDocuments: [],
      associateDialog: false,
      name: "",
      isLoading: true,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      key: 0,
      pagination: {},
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      activeTabName: "",
      markerPosition: {},
      recurringInvoice: null,
      transactions: [],
      ageAnalysis: {},
      sessionTab: 'active',
      taxTypes: [],
      tabs: [
        { name: "tags", displayName: "Tags" },
        {
          name: "locationNetworksLocations",
          displayName: "Associated Locations",
        },
        { name: "contactdocuments", displayName: "Documents" },
      ],
      invoiceHeaders: [
        {
          text: "Description",
          align: "center",
          value: "Description",
        },
        {
          text: "Quantity",
          align: "center",
          value: "Quantity",
        },
        {
          text: "Unit Price Excl. VAT",
          align: "center",
          value: "UnitPriceExclusive",
        },
        {
          text: "Unit Price Incl. VAT",
          align: "center",
          value: "UnitPriceInclusive",
        },
        {
          text: "Total",
          align: "center",
          value: "Total",
        },
      ],
      sessionHeaders: [
        {
          text: "NAS IP Address",
          align: "center",
          value: 'nasipaddress'
        },
        {
          text: "Framed IP Address",
          align: "center",
          value: 'framedipaddress'
        },
        {
          text: "Username",
          align: "center",
          value: 'username'
        }
        ,
        {
          text: "MAC Address",
          align: "center",
          value: 'callingstationid'
        },
        {
          text: "Session Start",
          align: "center",
          value: 'acctstarttime'
        },
        {
          text: "Session End",
          align: "center",
          value: 'acctstoptime'
        }
        ]
    };
  },
  watch: {
    "$route.params.contactId": {
      immediate: true,
      async handler(value) {
        if (typeof value !== "undefined") {
          if (value !== this.contactInfo.id) {
            let route = await this.$store.state.currentOrg.org.permissions.filter(
              function (el) {
                return el.url === "/contactSummary/:contactId";
              }
            );
            await this.$store.dispatch("setCurrentRoute", route[0]);
            if (this.authRead(this.$store.state.currentRoute)) {
              this.initialize();
            }
          }
        }
      },
    },
  },
  async created() {
    source = CancelToken.source();
    this.initialize();
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    fetchZhoneOnuStatus(handleId) {
      Api()
        .get(
          "/zhone/onuStatus/isp/" +
            this.serviceAccount.supplierOrganisationId +
            "/" +
            handleId,
          {
            cancelToken: source.token,
          }
        )
        .then((response) => {
          this.deviceStatus = {
            initiated: true,
            isOnline:
              response.data[0].onuStatusWord[0] == "00000000000000000000001" ||
              response.data[0].onuStatusWord[0] == "01000000000000000000001"
                ? true
                : false,
            complete: true,
          };
        });
    },
    fetchU2000OnuStatus(obj) {
      Api()
        .get("/u2000/ontStatus", {
          params: {
            deviceName: obj.upstreamDevice.systemName,
            frameId: obj.frame,
            slotId: obj.slot,
            portId: obj.port,
            onuId: obj.ponId,
          },
        })
        .then((res) => {
          this.deviceStatus = {};
          this.deviceStatus.isOnline =
            res.data.data.RUNSTAT == "Up" ? true : false;
          this.onuKey += 1;
        });
    },
    fetchDocuments() {
      Api()
        .get(
          "/upload/customerAccount/" +
            this.serviceAccount.contactId +
            "/" +
            this.serviceAccount.id
        )
        .then((response) => {
          this.contactDocuments = response.data;
          this.key += 1;
        });
    },
    fetchLocationsByContact() {
      Api()
        .get("/LocationContact/byContact/" + this.$route.params.contactId)
        .then((response) => {
          this.locations = response.data.map((x) => x.location);
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    routerLinkToDetails(item) {
      //   this.editedItem = Object.assign({}, item);
      this.$router.push({
        path: "/locationnetworks/" + item.locationNetworkId + "/" + item.id,
      });
    },
    fetchDatatillBillingInfo(accounting_code) {
      Api()
        .get("/datatill/billingDetails", {
          params: {
            accounting_code: accounting_code,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.datatillBillingDetails = res.data;
        });
    },
    fetchDatatillCustomerDetails(code) {
      Api()
        .get("/datatill/customerDetails", {
          params: {
            accounting_code: code,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.datatillCustomerDetails = res.data;
        });
    },
    fetchDatatillAgeAnalysis(code) {
      Api()
        .get("/datatill/ageAnalysis", {
          params: {
            accounting_code: code,
          },
        })
        .then((res) => {
          console.log(res.data.customer.age_analysis);
          this.datatillAgeAnalysis = res.data.customer.age_analysis;
        });
    },
    fetchActiveRadiusSessions(username) {
      Api()
        .get("/datatill/activeRadiusSessions", {
          params: {
            username: username,
          },
        })
        .then((res) => {
          this.activeRadiusSessions = res.data.active_sessions;
        });
    },
    fetchDataTillInfo(username) {
      Api()
        .get("/datatill/dataAccountDetails", {
          params: {
            username: username,
          },
        })
        .then((res) => {
          this.datatillData = res.data;
          console.log(res.data);
          if (this.datatillData && !this.datatillData.error) {
            let monthKeys = Object.keys(this.datatillData.monthly_usage);
            let months = [];
            for (let i = 0; i < monthKeys.length; i++) {
              months.push(this.datatillData.monthly_usage[monthKeys[i]]);
            }
            let dayKeys = Object.keys(this.datatillData.daily_usage);
            let days = [];
            for (let i = 0; i < dayKeys.length; i++) {
              days.push(this.datatillData.daily_usage[dayKeys[i]]);
            }

            this.datatillDataMonthly = {
              labels: months.map((x) => x.month),
              datasets: [
                {
                  label: "Download",
                  data: months.map(
                    (x) => parseInt(x.download) / (1024 * 1024 * 1024)
                  ),
                  backgroundColor: "#99cc33",
                  borderColor: "#99cc33",
                  borderWidth: 1,
                  fill: false,
                },
                {
                  label: "Upload",
                  data: months.map(
                    (x) => parseInt(x.upload) / (1024 * 1024 * 1024)
                  ),
                  backgroundColor: "#db120b",
                  borderColor: "#db120b",
                  borderWidth: 1,
                  fill: false,
                },
              ],
            };
            this.datatillDataMonthlyOptions = {
              title: {
                display: true,
                text: "Monthly Usage (Gb)",
                fill: false,
              },
            };

            this.datatillDataDaily = {
              labels: days.map((x) => x.day),
              datasets: [
                {
                  label: "Download",
                  data: days.map(
                    (x) => parseInt(x.download) / (1024 * 1024 * 1024)
                  ),
                  backgroundColor: "#99cc33",
                  borderColor: "#99cc33",
                  borderWidth: 1,
                  fill: false,
                },
                {
                  label: "Upload",
                  data: days.map(
                    (x) => parseInt(x.upload) / (1024 * 1024 * 1024)
                  ),
                  backgroundColor: "#db120b",
                  borderColor: "#db120b",
                  borderWidth: 1,
                  fill: false,
                },
              ],
            };
            this.datatillDataDailyOptions = {
              title: {
                display: true,
                text: "Daily Usage (Gb)",
                fill: false,
              },
            };
            this.fetchDatatillBillingInfo(
              this.datatillData.customer.accounting_code
            );
            this.fetchDatatillCustomerDetails(
              this.datatillData.customer.accounting_code
            );
            this.fetchDatatillAgeAnalysis(
              this.datatillData.customer.accounting_code
            );
          }

          this.datatillDataLoaded = true;
        });
    },
    getServiceAccount() {
      Api()
        .get("/serviceAccounts/" + this.$route.params.serviceAccountId)
        .then((res) => {
          this.serviceAccount = res.data;
          this.contactInfo = res.data.contact;
          if (
            this.serviceAccount &&
            this.serviceAccount.location &&
            this.serviceAccount.location.coordinates
          ) {
            let coordinates = JSON.parse(
              this.serviceAccount.location.coordinates
            );
            this.markerPosition = coordinates;
            this.center = this.markerPosition;
          } else if (
            this.serviceAccount.location.locationNetwork.geoLatitude &&
            this.serviceAccount.location.locationNetwork.geoLongitude
          ) {
            this.markerPosition = {
              lat: parseFloat(
                this.serviceAccount.location.locationNetwork.geoLatitude
              ),
              lng: parseFloat(
                this.serviceAccount.location.locationNetwork.geoLongitude
              ),
            };
            this.center = this.markerPosition;
          }
          this.fetchDocuments();
          // if (this.datatillIntegration) {
          //   this.fetchDataTillInfo(this.serviceAccount.pppoeUsername);
          //   this.fetchActiveRadiusSessions(this.serviceAccount.pppoeUsername);
          // }
          if (
            this.serviceAccount.device &&
            this.serviceAccount.device.isU2000
          ) {
            this.fetchU2000OnuStatus(this.serviceAccount.device);
          } else if (
            this.serviceAccount.device &&
            this.serviceAccount.device.Handle_ID
          ) {
            this.fetchZhoneOnuStatus(this.serviceAccount.device.Handle_ID);
          }
        });
    },
    async checkDatatillIntegration() {
      let result = false;
      await Api()
        .get("/datatill/integrationCheck")
        .then((res) => {
          result = res.data;
        });
      return result;
    },

    async initialize() {
      this.datatillIntegration = await this.checkDatatillIntegration();
      await this.getCustomerAccount();
      if (
        this.$store.state.currentOrg.org.accountingSystem == "SageOne" &&
        this.customerAccount.accountingCustomerId
      ) {
        this.fetchSageCustomerDetails(
          this.customerAccount.accountingCustomerId
        );
        this.fetchTransactions(this.customerAccount.accountingCustomerId);
        this.fetchSageTaxTypes();
        if (this.customerAccount.recurringInvoiceId) {
          this.fetchRecurringInvoice(this.customerAccount.recurringInvoiceId);
        }
      }
    },
    async fetchRecurringInvoice(id) {
      await Api()
        .get("/sageOne/recurringinvoice/" + id)
        .then((res) => {
          this.recurringInvoice = res.data;
        });
    },
    async fetchSageTaxTypes() {
      await Api()
        .get("/sageOne/taxTypes")
        .then((res) => {
          this.taxTypes = res.data.Results;
        });
    },
    async fetchTransactions(id) {
      await Api()
        .get("/sageOne/customer/transactions/" + id)
        .then((res) => {
          if (res.data.length > 0) {
            this.transactions = res.data;
          }
        });
    },
    fetchSageCustomerDetails(customerId) {
      Api()
        .get("/sageOne/ageAnalysisSummary/" + customerId)
        .then((res) => {
          this.ageAnalysis = res.data;
        });
    },
    fetchRadiusActiveSessions() {
      Api()
        .get("/radius/sessions/all/active/"+this.customerAccount.username)
        .then((res) => {
          this.activeRadiusSessions = res.data;
        });
    },
    fetchPreviousSessions(){
      
      Api()
        .get("/radius/sessions/"+this.customerAccount.username)
        .then((res) => {
          this.previousRadiusSessions = res.data;
        });
    },
    async getCustomerAccount() {
      await Api()
        .get("/customerAccount/" + this.$route.params.customerAccountId)
        .then((res) => {
          this.customerAccount = res.data;
          this.serviceAccount = res.data.serviceAccount;
          this.device = res.data.device;
          this.contactInfo = res.data.contact;
          if (
            this.serviceAccount &&
            this.serviceAccount.location &&
            this.serviceAccount.location.coordinates
          ) {
            let coordinates = JSON.parse(
              this.serviceAccount.location.coordinates
            );
            this.markerPosition = coordinates;
            this.center = this.markerPosition;
          } else if (
            this.serviceAccount.location.locationNetwork.geoLatitude &&
            this.serviceAccount.location.locationNetwork.geoLongitude
          ) {
            this.markerPosition = {
              lat: parseFloat(
                this.serviceAccount.location.locationNetwork.geoLatitude
              ),
              lng: parseFloat(
                this.serviceAccount.location.locationNetwork.geoLongitude
              ),
            };
            this.center = this.markerPosition;
          }
          this.fetchDocuments();
          if (this.datatillIntegration) {
            // this.fetchDataTillInfo(this.serviceAccount.pppoeUsername);
            // this.fetchActiveRadiusSessions(this.serviceAccount.pppoeUsername);
          }
          if(this.$store.state.currentOrg.org.radiusIntegration){
            this.fetchRadiusActiveSessions()
            this.fetchPreviousSessions()
          }
          if (
            this.serviceAccount.device &&
            this.serviceAccount.device.isU2000
          ) {
            this.fetchU2000OnuStatus(this.serviceAccount.device);
          } else if (
            this.serviceAccount.device &&
            this.serviceAccount.device.Handle_ID
          ) {
            this.fetchZhoneOnuStatus(this.serviceAccount.device.Handle_ID);
          }
        });
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },
  },
};
</script>
